/* eslint-disable no-shadow */
import { call, takeEvery } from "redux-saga/effects";
import noop from "lodash.noop";

import {
    CURRENT_WORKFLOWINSTANCE_REQUESTED,
    defaultScopeId,
    failCurrentWorkflowinstance,
    succeedCurrentWorkflowinstance,
} from "./workflowinstance.duck";

import { loadCurrentWorkflowinstance } from "./workflowinstance.api";

import { injectBoundGQLClient } from "Utils/injectBoundGQLClient";

import {
    getId,
    injectApiWithContextFactory,
    injectBoundActionCreatorsFactory,
    withRefreshRequest,
} from "Utils/sagaUtils";

export const withBoundActions = injectBoundActionCreatorsFactory(
    {
        succeedCurrentWorkflowinstance,
        failCurrentWorkflowinstance,
    },
    getId,
    defaultScopeId
);

export const withApiContext = injectApiWithContextFactory(
    {
        loadCurrentWorkflowinstance,
    },
    injectBoundGQLClient
);

export function* loadCurrentWorkflowinstanceSaga({
    actions: { succeedCurrentWorkflowinstance, failCurrentWorkflowinstance },
    api: { loadCurrentWorkflowinstance },
    resolve = noop,
    reject = noop,
}) {
    try {
        const result = yield loadCurrentWorkflowinstance();
        yield succeedCurrentWorkflowinstance(result);
        yield call(resolve);
    } catch (e) {
        yield failCurrentWorkflowinstance(e);
        yield call(reject, e);
    }
}

export default () =>
    function* rootSaga() {
        yield takeEvery(
            CURRENT_WORKFLOWINSTANCE_REQUESTED,
            withRefreshRequest(withBoundActions(withApiContext(loadCurrentWorkflowinstanceSaga)))
        );
    };
